<section class="content">
  <mat-form-field>
    <mat-label>Select Coefficients Set</mat-label>
    <input type="text" placeholder="Search Coefficients Set name" matInput
      [formControl]="coefficientsSetControl" [matAutocomplete]="autoCoefficients" (focus)="onFocus()"
      (blur)="updateCoefficients($event.target.value)" (input)="coefficientsSetChanges.next($event.target.value)" />
    <mat-autocomplete #autoCoefficients="matAutocomplete" (optionSelected)="setCoefficientsChangeAction($event)">
      @for (option of coefficientsSetSuggestions | async; track option) {
        <mat-option [value]="option">
          {{ option }}
        </mat-option>
      }
    </mat-autocomplete>
    @if (coefficientsSetControl.hasError('noOption')) {
      <mat-error>
        Coefficients Set not Found
      </mat-error>
    }
    @if (coefficientsSetControl.hasError('required')) {
      <mat-error>
        Coefficients Set is required
      </mat-error>
    }
  </mat-form-field>

  <mat-form-field>
    <mat-label>Coefficient set name</mat-label>
    <input disabled matInput placeholder="Coefficient set name" [value]="(coefficientSetName$ | async)">
  </mat-form-field>
</section>